export const REFERENCE_IMAGE_SIZE = 10000;
export const MIN_CIRCLE_SIZE_SCALE = 0.3;

export const ZOOM_CONFIG = {
  MIN: 0.01,
  MAX: 5,
  // Wheel, buttons and pinch may go further than programmatic zoom-to-object/elements.
  MANUAL_MAX: 20,
  // Share of the viewport the selected element's bbox fills after auto zoom.
  AUTO_ZOOM_FILL_FRACTION: 0.2,
  BUTTON_IN_FACTOR: 0.2, // Delta for zoom in button
  BUTTON_OUT_FACTOR: -0.2, // Delta for zoom out button
  WHEEL_SENSITIVITY: 0.0025,
  WHEEL_PIXEL_MODE_MULTIPLIER: 5,
  WHEEL_LINE_MODE_MULTIPLIER: 40,
  WHEEL_MAX_DELTA: 200,
  TRANSITION_DURATION: "0.15s",
  PAN_TRANSITION: "transform 0.3s ease-out",
  ANIMATED_ZOOM_DURATION_MS: 300,
} as const;

export const PLAN_CHESSBOARD = {
  x: {
    F: 468,
    G: 1236,
    H: 6440,
    I: 9044,
    F1: 590,
    G1: 1886,
    G2: 2537,
    G3: 3188,
    G4: 3843,
    G5: 4491,
    G6: 5136,
    G7: 5790,
    H1: 7088,
    H2: 7739,
    H3: 8390,
    I1: 9690,
    I2: 10340,
    I3: 10990,
    I4: 11644,
    I5: 12300,
  },
  y: {
    "31": 9530,
    "32": 8880,
    "33": 8230,
    "34": 7580,
    "35": 6930,
    "36": 6280,
    "37": 5620,
    "38": 4978,
    "39": 4330,
    "40": 3680,
    "41": 3025,
    "42": 2375,
    "43": 1730,
    "44": 1070,
    "45": 500,
  },
} as const;
